import { ethers } from "ethers";

// Polygon Mainnet
// const defaultRPC = "https://polygon-bor.publicnode.com";
 const defaultRPC = [
'https://polygon-rpc.com/',
'https://polygon-mainnet.infura.io/',
'https://polygon-bor-rpc.publicnode.com/' ,
'https://polygon-mainnet.g.alchemy.com/',
'https://polygon-mainnet.core.chainstack.com',
'https://polygon-mainnet.public.blastapi.io',]


// const defaultRPC = "https://polygon-rpc.com";

// BSC Testnet
// const defaultRPC = "https://data-seed-prebsc-1-s1.binance.org:8545/";
//const defaultRPC = https://bnb-testnet.g.alchemy.com/v2/AoLZalsCaUwdHaSWYhaad

// const defaultRPC = "https://rpc-amoy.polygon.technology";
// const defaultRPC = "https://polygon.llamarpc.com";
// const defaultRPC = "https://polygon-bor.publicnode.com";
// const defaultRPC = "http://127.0.0.1:8545/";

const getProvider = (defaultRpc = false) => {
    if (window.ethereum && !defaultRpc) {
        return new ethers.providers.Web3Provider(window.ethereum);
    }
    return new ethers.providers.JsonRpcProvider(defaultRPC);
};

export default getProvider;


